import React, { Component } from 'react';
import TestEditor from "./testedit/TestEditor";
import Test from "./test/Test";

class TestView extends Component {
    render() {
        const isLecturer = this.props.user.user_type === 'lecturer';

        if (isLecturer) {
            return <TestEditor
                id={this.props.id}
                openList={this.props.openList}
            />;
        } else {
            return <Test
                id={this.props.id}
                openList={this.props.openList}
            />;
        }
    }
}

export default TestView;